var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 167,
    viewBox: "0 0 200 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_742_4857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29298 159.093C12.0672 164.238 17.955 166.447 17.955 166.447C17.955 166.447 19.345 160.314 16.5708 155.169C13.7966 150.024 7.90876 147.815 7.90876 147.815C7.90876 147.815 6.51878 153.948 9.29298 159.093Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2001 157.4C16.2087 160.414 18.1377 166.399 18.1377 166.399C18.1377 166.399 11.9461 167.499 6.93753 164.485C1.92896 161.472 0 155.487 0 155.487C0 155.487 6.19154 154.387 11.2001 157.4Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.492 8.01465H92.2422V8.46108H123.492V8.01465Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.011 8.34961H114.564V12.4791H115.011V8.34961Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.396 8.34961H100.949V12.4791H101.396V8.34961Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.342 29.4434H108.092V29.8898H139.342V29.4434Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.021 25.4258H116.574V29.5552H117.021V25.4258Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.636 25.4258H130.189V29.5552H130.636V25.4258Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.859 39.4883H149.609V39.9347H180.859V39.4883Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.538 35.4707H158.092V39.6002H158.538V35.4707Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.153 35.4707H171.707V39.6002H172.153V35.4707Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.734 143.06H146.484V143.506H177.734V143.06Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.413 139.042H154.967V143.171H155.413V139.042Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.028 139.042H168.582V143.171H169.028V139.042Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.387 71.4082H93.1367V71.8546H124.387V71.4082Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.064 67.3896H101.617V71.5191H102.064V67.3896Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.681 67.3896H115.234V71.5191H115.681V67.3896Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.207 125.203H102.957V125.65H134.207V125.203Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.886 121.185H111.439V125.314H111.886V121.185Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.501 121.185H125.055V125.314H125.501V121.185Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.207 108.908H152.957V109.355H184.207V108.908Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.886 104.89H161.439V109.019H161.886V104.89Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.501 104.89H175.055V109.019H175.501V104.89Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8169 156.737H27.9629V156.357H80.4365V137.915H32.4062L30.0729 133.054L30.4158 132.89L32.6455 137.535H80.8169V156.737Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9965 166.054C37.2015 166.054 38.9891 164.266 38.9891 162.061C38.9891 159.856 37.2015 158.068 34.9965 158.068C32.7914 158.068 31.0039 159.856 31.0039 162.061C31.0039 164.266 32.7914 166.054 34.9965 166.054Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3519 166.054C76.557 166.054 78.3445 164.266 78.3445 162.061C78.3445 159.856 76.557 158.068 74.3519 158.068C72.1469 158.068 70.3594 159.856 70.3594 162.061C70.3594 164.266 72.1469 166.054 74.3519 166.054Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.743 79.7381C122.108 79.7381 123.215 78.6315 123.215 77.2665C123.215 75.9015 122.108 74.7949 120.743 74.7949C119.378 74.7949 118.271 75.9015 118.271 77.2665C118.271 78.6315 119.378 79.7381 120.743 79.7381Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4697 131.641H27.0616L14.207 89.624H99.708L99.6302 89.8712L86.4697 131.641ZM27.3428 131.261H86.1909L99.1896 90.0043H14.721L27.3428 131.261Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8323 129.454H29.652L18.3613 92.1904H93.4598L93.3915 92.4098L81.8323 129.454Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.774 85.8703L100.406 85.7728L102.915 76.3154H117.511V76.6958H103.208L100.774 85.8703Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4357 102.362H18.3613V102.743H95.4357V102.362Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0212 116.371H22.6465V116.751H91.0212V116.371Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1459 89.8145H56.7656V131.451H57.1459V89.8145Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.171 89.8027L71.4414 131.438L71.8209 131.463L74.5504 89.8276L74.171 89.8027Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7506 89.8024L39.3711 89.8271L42.0848 131.464L42.4643 131.439L39.7506 89.8024Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 166.295H0V166.741H200V166.295Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.904 13.8118C132.904 13.8118 136.167 23.0989 134.159 24.5277C132.151 25.9565 140.936 37.6249 140.936 37.6249L151.479 34.7673L145.705 25.0039C145.705 25.0039 144.952 15.2406 144.952 13.8118C144.952 12.383 132.904 13.8118 132.904 13.8118Z",
    fill: "#EECCD1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M132.904 13.8118C132.904 13.8118 136.167 23.0989 134.159 24.5277C132.151 25.9565 140.936 37.6249 140.936 37.6249L151.479 34.7673L145.705 25.0039C145.705 25.0039 144.952 15.2406 144.952 13.8118C144.952 12.383 132.904 13.8118 132.904 13.8118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.427 80.0125C127.427 80.0125 126.475 91.919 127.427 98.1105C128.38 104.302 129.809 121.447 129.809 121.447C129.809 121.447 129.809 153.833 135.047 154.309C140.286 154.786 144.096 155.262 144.573 153.357C145.049 151.452 142.191 150.499 143.62 149.547C145.049 148.594 145.525 145.26 143.62 141.45C141.715 137.64 143.62 99.063 143.62 99.063L152.669 123.352C152.669 123.352 153.622 143.355 154.574 146.213C155.527 149.071 153.622 154.309 156.956 154.786C160.289 155.262 164.099 152.404 166.004 151.452C167.91 150.499 163.147 150.499 164.099 150.023C165.052 149.547 167.91 148.118 166.957 147.642C166.004 147.165 165.052 124.305 165.052 124.305C165.052 124.305 162.433 75.488 159.099 73.583C155.765 71.6779 153.622 74.9592 153.622 74.9592L127.427 80.0125Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.001 152.404V156.214C136.001 156.214 131.714 166.571 136.001 166.571C140.287 166.571 143.621 167.645 143.621 166.216V153.357L136.001 152.404Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.099 152.397V156.208C164.099 156.208 168.385 166.565 164.099 166.565C159.812 166.565 156.479 167.638 156.479 166.209V153.35L164.099 152.397Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.573 20.7177C144.307 20.7177 148.145 16.8796 148.145 12.145C148.145 7.4104 144.307 3.57227 139.573 3.57227C134.838 3.57227 131 7.4104 131 12.145C131 16.8796 134.838 20.7177 139.573 20.7177Z",
    fill: "#EECCD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.953 28.0996C136.953 28.0996 139.334 35.2435 143.144 33.8148L146.954 32.386L153.622 78.1071C153.622 78.1071 148.383 85.7273 140.763 80.9647C133.142 76.2021 136.953 28.0996 136.953 28.0996Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.619 26.671L145.762 22.1465C145.762 22.1465 158.383 28.0998 160.288 30.0048C162.193 31.9099 162.193 34.7674 162.193 34.7674L158.86 46.674C158.86 46.674 159.812 72.8684 159.812 73.8209C159.812 74.7735 163.146 80.0124 160.765 78.1073C158.383 76.2023 157.907 74.2972 156.002 77.1548C154.097 80.0124 149.811 83.3462 149.811 83.3462L143.619 26.671Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.289 60.9619L158.86 74.2973C158.86 74.2973 150.287 81.9175 152.192 82.3937C154.097 82.87 155.05 80.9649 155.05 80.9649C155.05 80.9649 158.384 84.2988 160.289 82.3937C162.194 80.4887 166.956 62.3907 166.956 62.3907L160.289 60.9619Z",
    fill: "#EECCD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.754 0.0289891C137.854 -0.0389507 135.82 -0.072558 134.218 0.95158C133.48 1.46555 132.834 2.09856 132.304 2.82469C130.744 4.79756 129.395 7.27988 129.975 9.72768L130.648 9.46509C130.648 10.1185 130.503 10.7637 130.223 11.3541C130.318 11.0784 130.635 11.524 130.55 11.8029L129.809 14.2361C131.028 13.7891 132.544 14.6941 132.73 15.9793C132.815 13.1532 133.108 9.91245 135.401 8.25761C136.557 7.42308 138.02 7.16833 139.428 6.9421C140.726 6.73339 142.088 6.53438 143.332 6.96193C144.576 7.38949 145.635 8.66171 145.353 9.94651C145.927 9.74893 146.568 10.1487 146.852 10.685C147.135 11.2214 147.15 11.8541 147.159 12.4607C147.77 12.8928 148.466 12.0348 148.715 11.3288C149.3 9.67155 149.82 7.90748 149.505 6.17855C149.19 4.44961 147.781 2.79736 146.023 2.79149C146.237 2.55719 146.351 2.24911 146.341 1.9324L144.892 1.81001C145.26 1.75794 145.598 1.57964 145.849 1.30565C145.267 1.94559 140.695 0.0626074 139.754 0.0289891Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.334 25.2419C139.334 25.2419 135.457 21.4426 134.062 21.6753C132.667 21.908 130.761 25.2419 130.761 25.2419C130.761 25.2419 119.331 29.052 119.807 32.8621C120.284 36.6722 125.523 55.2464 125.523 55.2464C125.523 55.2464 129.809 77.6307 125.999 80.012C122.189 82.3933 144.097 88.5848 144.573 85.7272C145.049 82.8696 146.002 54.2939 144.573 50.0075C143.144 45.7212 139.334 25.2419 139.334 25.2419Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.002 32.8623H161.891C161.891 32.8623 166.003 50.9603 166.48 52.8653C166.956 54.7704 167.909 63.8194 167.432 63.8194C166.956 63.8194 157.431 61.9143 157.431 63.3431L156.002 32.8623Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.803 77.6786H133.259C131.059 67.558 130.875 57.7798 133.259 48.4375H155.803C152.165 57.6118 151.938 67.323 155.803 77.6786Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.094 65.2477L130.761 68.1052C130.761 68.1052 143.621 70.0103 143.621 64.7714C143.621 59.5325 130.761 62.3901 130.761 62.3901L126.475 61.0195L124.094 65.2477Z",
    fill: "#EECCD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.522 30.0049L119.807 31.4337L115.521 56.6756C115.521 56.6756 114.092 63.3432 116.473 63.8195C118.855 64.2958 125.522 68.1059 125.522 68.1059C125.522 68.1059 126.475 60.9619 128.38 60.9619L123.617 57.1518L126.475 40.4827L125.522 30.0049Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6992 78.7744H13.4492V79.2208H44.6992V78.7744Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3761 74.7559H21.9297V78.8853H22.3761V74.7559Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9933 74.7559H35.5469V78.8853H35.9933V74.7559Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6367 12.7021H24.3867V13.1486H55.6367V12.7021Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1535 13.0371H46.707V17.1666H47.1535V13.0371Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5382 13.0371H33.0918V17.1666H33.5382V13.0371Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1094 56.6758H55.8594V57.1222H87.1094V56.6758Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6261 57.0107H78.1797V61.1402H78.6261V57.0107Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0109 57.0107H64.5645V61.1402H65.0109V57.0107Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9844 56.4521H2.73438V56.8986H33.9844V56.4521Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5011 56.7871H25.0547V60.9166H25.5011V56.7871Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8859 56.7871H11.4395V60.9166H11.8859V56.7871Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4844 34.1309H40.2344V34.5773H71.4844V34.1309Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1632 30.1133H48.7168V34.2427H49.1632V30.1133Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7785 30.1133H62.332V34.2427H62.7785V30.1133Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_742_4857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 166.958,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.4a0e5a3aec5717a0004385cf26ab6449.svg";
export { ForwardRef as ReactComponent };